import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global.js';
import { getEntityBlocks } from 'gql/common/blocks';
import { CORE_POST_FIELDS, CORE_POST_FIELDS_KEY, LATEST_100_POSTS, getPosts } from 'gql/posts';
import { GetServerSideProps, GetServerSidePropsContext, GetStaticPropsContext } from 'next';
import { Category, Post } from 'generated-graphql';
import DefaultAsset from '@/components/Series/DefaultAsset';
import Head from 'next/head';

export default function Resource({
  pageBlocks,
  seriesParts,
}: {
  pageBlocks: Post;
  seriesParts: Post[] | null;
}) {

  return (
    <>
      <DefaultAsset pageBlocks={pageBlocks} seriesParts={seriesParts} />
    </>
  );
}

// export async function getStaticPaths() {
//   const apolloClient = initializeApollo();
//   const latest = await apolloClient.query({
//     query: LATEST_100_POSTS,
//   });

//   const data = latest?.data?.posts.nodes || [];

//   return {
//     paths:
//       data.map((node: Post) => {
//         return `/resources/${node.slug}`;
//       }) || [],
//     fallback: 'blocking',
//   };
// }

// export async function getStaticProps(context: GetStaticPropsContext) {
//   const { params } = context;

//   const apolloClient = initializeApollo();

//   const pageBlocks = await apolloClient.query({
//     query: getEntityBlocks('post', CORE_POST_FIELDS, CORE_POST_FIELDS_KEY),
//     variables: {
//       id: params?.slug,
//       idType: 'SLUG',
//       asPreview: false,
//     },
//   });

//   // Resource not found
//   if (!pageBlocks?.data?.post?.id) {
//     return {
//       notFound: true,
//     };
//   }

//   const seriesCategory =
//     pageBlocks?.data?.post.categories?.nodes?.find(
//       (c: Category) => c.parent?.node?.name === 'Series',
//     ) || null;
//   let seriesParts = null;
//   if (seriesCategory) {
//     seriesParts = await apolloClient.query({
//       query: getPosts([seriesCategory.name]),
//       variables: { first: 5 },
//     });
//   }

//   const pageProps = {
//     pageBlocks: pageBlocks?.data?.post,
//     seriesParts:
//       seriesParts?.data?.posts?.nodes.filter(
//         (post: Post) => post.title !== pageBlocks?.data?.post.title,
//       ) || null,
//   };

//   return await getGlobalData(pageProps, apolloClient);
// };

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { query } = context;
  const apolloClient = initializeApollo();

  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks('post', CORE_POST_FIELDS, CORE_POST_FIELDS_KEY),
    variables: {
      id: query.slug,
      idType: 'SLUG',
      asPreview: false,
    },
  });

  // Resource not found
  if (!pageBlocks?.data?.post?.id) {
    return {
      notFound: true,
    };
  }

  const seriesCategory =
    pageBlocks?.data?.post.categories?.nodes?.find(
      (c: Category) => c.parent?.node?.name === 'Series',
    ) || null;
  let seriesParts = null;
  if (seriesCategory) {
    seriesParts = await apolloClient.query({
      query: getPosts([seriesCategory.name]),
      variables: { first: 5 },
    });
  }

  const pageProps = {
    pageBlocks: pageBlocks?.data?.post,
    seriesParts:
      seriesParts?.data?.posts?.nodes.filter(
        (post: Post) => post.title !== pageBlocks?.data?.post.title,
      ) || null,
  };

  return await getGlobalData(pageProps, apolloClient);
};
